<template>
    <BreadCrumb PageTitle="Liste des partenaires" />
    <ListePartenaire />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListePartenaire from "@/components/Partenaires/ListePartenaire.vue";

export default defineComponent({
    name: "ListePartenairePage",
    components: {
        BreadCrumb,
        ListePartenaire,
    },
});
</script>